import { ServiceData } from '../service';
import db from '../index';
import { entityServiceFactory } from '../entityServiceFactory';

export interface DirectoriesServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<DirectoriesServiceData>(db, 'directoriesService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
